(function($){
    $(function(){
      const $slides = $('.pro_lp-fade-layer');
      const $heading2 =$('.mv_h2');
      const $menuLinks = $('.mv ul li a');
      const $heading1 =$('.mv_h1');
      let current = 0;
  
      $slides.eq(current).addClass('pro_lp-show');
  
      setInterval(() => {
        $slides.eq(current).removeClass('pro_lp-show');
        current = (current + 1) % $slides.length;
        $slides.eq(current).addClass('pro_lp-show');

      // 2枚目のときだけ文字色を白にする
      if (current === 1) {
        $heading1.addClass('pro_lp-white');
        $heading2.addClass('pro_lp-white');
        $menuLinks.addClass('pro_lp-white');

      } else {
        $heading1.removeClass('pro_lp-white');
        $heading2.removeClass('pro_lp-white');
        $menuLinks.removeClass('pro_lp-white');
      }

      }, 4000);
    });
  })(jQuery);
  